export const MISSING_ROOT_TAGS_ERROR = 'NEXT_MISSING_ROOT_TAGS';

//# sourceMappingURL=constants.js.map